<template>
  <div class="container college">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>应用管理</el-breadcrumb-item>
        <el-breadcrumb-item>菜单管理</el-breadcrumb-item>
        <el-breadcrumb-item>菜单列表</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">菜单列表</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="goPositionList"
          >位置管理</el-button>
          <el-button
            class="button"
            type="primary"
            @click="handleAdCreate"
          >添加菜单</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item
          label="菜单标题"
          prop="title"
        >
          <el-input
            v-model="query.title"
            placeholder="输入菜单标题"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="菜单位置"
          prop="position_code"
        >
          <el-select
            v-model="query.position_code"
            placeholder="请选择"
          >
            <el-option
              v-for="item in positions"
              :key="item.id"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="状态"
          prop="status"
        >
          <el-select
            v-model="query.status"
            placeholder="请选择"
          >
            <el-option
              v-for="item in filter.status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="divider"></div>
      <div class="action-wrap">
        <el-button
          type="primary"
          @click="handleSearch"
        >搜索</el-button>
        <el-button @click="handleFormReset('searchForm')">重置</el-button>
      </div>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">查找结果</p>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="title"
            label="菜单标题"
            min-width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="link_url"
            label="菜单链接"
            min-width="180"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="icon"
            label="菜单图标"
            min-width="150"
            align="center"
          >
            <template slot-scope="scope">
              <img
                :src="scope.row.icon"
                style="max-height: 50px; display: block; margin: 0 auto"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="position_code"
            label="菜单位置"
            min-width="160"
            align="center"
          >
            <template slot-scope="scope">
              {{ renderPositionName(scope.row.position_code) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="sort"
            label="排序值"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="状态"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag :type="scope.row.status == 1 ? 'success' : 'danger'">{{
                scope.row.status == 1 ? "正常" : "下线"
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="180"
            align="center"
            fixed="right"
            v-if="isfixed"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="handleToAdEdit(scope.row, scope.$index)"
              >编辑</el-button>
              <el-button
                class="remove-text-button"
                size="mini"
                type="text"
                @click="handleToAdRemove(scope.row, scope.$index)"
              >删除</el-button>
            </template>
          </el-table-column>
          <el-table-column
            label=""
            width="40"
            align="center"
            fixed="right"
            v-else
          >
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  ...
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    command="a"
                    style="margin-bottom:6px;"
                  ><span
                      @click="handleToAdEdit(scope.row, scope.$index)"
                      style="font-size:16px;color: #409EFF;"
                    >
                      编辑
                    </span></el-dropdown-item>
                  <el-dropdown-item
                    command="d"
                    style="margin-bottom:6px;"
                  ><span
                      @click="handleToAdRemove(scope.row, scope.$index)"
                      style="font-size:16px;color: #F56C6C;"
                    >
                      删除
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <MenuCreate
      :visible="createDialog"
      @close="createDialog = false"
      @submit="fetchMenuList"
    ></MenuCreate>
    <MenuEdit
      :visible="editDialog"
      :content="editRow"
      @close="editDialog = false"
      @submit="fetchMenuList"
    ></MenuEdit>
  </div>
</template>

<script>
import MenuCreate from "@/components/dialog/menu/MenuCreate";
import MenuEdit from "@/components/dialog/menu/MenuEdit";
import { menuList, menuPositionList, menuDestroy } from "@/api/operation";

export default {
  components: {
    MenuCreate,
    MenuEdit,
  },
  data() {
    return {
      createDialog: false,
      editDialog: false,
      editRow: {
        ref_content: {},
      },
      query: {
        title: "",
        position_code: "",
        status: "",
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      filter: {
        status: [
          { label: "全部", value: "" },
          { label: "正常", value: "1" },
          { label: "关闭", value: "0" },
        ],
        types: [
          { label: "全部", value: "" },
          { label: "统考", value: "1" },
          { label: "非统考", value: "0" },
        ],
      },
      positions: [],
      results: [],
      isfixed: document.body.clientWidth < 820 ? false : true,
    };
  },
  created() {
    this.parseQuery();
    this.fetchPositionList();
    this.fetchMenuList();
  },
  methods: {
    // 菜单位置列表请求
    fetchPositionList() {
      menuPositionList({ isPaging: 0 }).then((res) => {
        let list = res.list;
        list.unshift({ id: "", code: "", name: "全部" });
        this.positions = res.list;
      });
    },
    // 菜单列表请求
    fetchMenuList() {
      menuList(this.query).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
      this.syncQuery();
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchMenuList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchMenuList();
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.fetchMenuList();
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields();
      this.fetchMenuList();
    },
    renderPositionName(code) {
      if (!code) {
        return "";
      }
      const list = this.positions.filter((item) => item.code == code);
      if (list.length) {
        return list[0].name;
      }
      return "";
    },
    // 部分内容渲染
    handleRender(value, type) {
      let status = {
        1: "正常",
        2: "关闭",
      };
      if (type == "status") {
        return status[value] || "";
      }
      return "";
    },
    // 菜单创建
    handleAdCreate() {
      this.createDialog = true;
    },
    // 菜单编辑
    handleToAdEdit(row) {
      this.editRow = Object.assign({}, row, {
        status: row.status == 1 ? true : false,
      });
      this.editDialog = true;
    },
    // 菜单删除
    handleToAdRemove(row) {
      // 二次确认删除
      this.$confirm("确定要删除吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          menuDestroy({ id: row.id }).then((res) => {
            this.$message.success(`删除成功`);
            this.fetchMenuList();
          });
        })
        .catch(() => { });
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      );
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        });
    },
    goPositionList() {
      this.$router.push(`/menu/position`);
    },
  },
};
</script>

<style scoped lang="less">
.college {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
  }
}
</style>
